<template>
  <v-container
    fluid
    class="fill-height d-flex flex-column justify-center align-center"
    style="background: linear-gradient(135deg, #1a2842, #495e79)"
  >
    <!-- App Logo -->
    <div class="mb-8 d-flex flex-column align-center">
      <v-img
        :src="require('@/assets/mobipoly-logo.png')"
        alt="Mobipoly Logo"
        width="150"
        height="150"
        class="mb-4"
      />
    </div>

    <!-- Buttons Section -->
    <div class="d-flex flex-column align-center" style="width: 100%">
      <v-btn flat class="gradient-bg mb-6" width="250" large @click="goBanker">
        Create Game
      </v-btn>

      <v-btn flat class="gradient-border" width="250" large @click="goPlayer">
        Join Game
      </v-btn>
    </div>

    <!-- Exit Dialog -->
    <v-dialog v-model="showExitDialog" max-width="350">
      <v-card>
        <v-card-title class="text-h6">Exit App</v-card-title>
        <v-card-text>Are you sure you want to close the app?</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancelExit">Cancel</v-btn>
          <v-btn color="red" text @click="closeApp">Exit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup>
import { useRouter } from "vue-router";
import { ref, onMounted, onUnmounted } from "vue";
import { App as CapacitorApp } from "@capacitor/app";

const router = useRouter();
const showExitDialog = ref(false);

function goBanker() {
  router.push("/banker/start");
}
function goPlayer() {
  router.push("/player/start");
}

function closeApp() {
  CapacitorApp.exitApp();
}
function cancelExit() {
  showExitDialog.value = false;
}

onMounted(() => {
  CapacitorApp.addListener("backButton", () => {
    showExitDialog.value = true;
  });
});
onUnmounted(() => {
  CapacitorApp.removeAllListeners();
});
</script>

<style scoped>
.gradient-bg {
  background: linear-gradient(45deg, #1f7673, #156bae);
  color: white !important;
  border-radius: 0px;
  text-transform: none;
  transition: background 0.3s ease;
}

.gradient-bg:hover {
  background: linear-gradient(45deg, #156bae, #1f7673);
}

.gradient-border {
  background: transparent !important;
  border: 2px solid;
  border-image-slice: 1;
  border-width: 2px;
  border-image-source: linear-gradient(45deg, #1f7673, #156bae);
  color: #fff;
  text-transform: none;
  box-shadow: none;
}
</style>
